// Loading strategies
export const IMAGE_LOADING = {
  EAGER: 'eager',
  LAZY: 'lazy',
} as const;

// Breakpoints
export const BREAKPOINTS = {
  SM: 600,
  MD: 960,
  LG: 1280,
  XL: 1920,
} as const;

// Image trim strategies
export const IMAGE_TRIM = {
  AUTO: 'Auto',
  NONE: 'None',
} as const;

export const ImageFetchPriority = {
  Auto: 'auto',
  High: 'high',
  Low: 'low',
} as const;

// Image defaults (moved from Image.tsx)
export const DESKTOP_IMAGE_WIDTH = '100vw';
export const DESKTOP_BREAKPOINT_DEFAULT = 'MD';
export const MOBILE_BREAKPOINT_DEFAULT = 'SM';
export const ROOT_MARGIN_INTERSECTION = '100px';

// Responsive data default
export const RESPONSIVE_DATA_DEFAULT = {
  sizes: '',
  src: '',
  srcSet: '',
} as const;

// Backward compatibility exports (deprecated - use uppercase versions)
/** @deprecated Use IMAGE_LOADING instead */
export const ImageLoading = IMAGE_LOADING;
/** @deprecated Use BREAKPOINTS instead */
export const Breakpoints = BREAKPOINTS;
/** @deprecated Use IMAGE_TRIM instead */
export const ImageTrim = IMAGE_TRIM;
